var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2218_7364",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9999 19.5C26.892 19.5 19.5 26.892 19.5 35.9999C19.5 44.2334 25.539 51.0644 33.4259 52.3019V40.7684H29.235V35.9999H33.4259V32.37C33.4259 28.2285 35.8844 25.9515 39.6629 25.9515C41.4614 25.9515 43.3589 26.2815 43.3589 26.2815V30.3405H41.2799C39.2339 30.3405 38.5904 31.611 38.5904 32.9145V36.0164H43.1609L42.4349 40.7849H38.5904V52.3184C46.4774 51.0809 52.4999 44.2334 52.4999 35.9999C52.4999 26.892 45.1244 19.5165 36.0164 19.5165L35.9999 19.5Z",
    fill: "#171719"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2218_7364)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 39.9998,
    height: 39.9999,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookPortfolio);
export default __webpack_public_path__ + "static/media/facebook_portfolio.46e5c49ed6110e1d5d1515bd25d5554f.svg";
export { ForwardRef as ReactComponent };